import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f47c09d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "form-item-header" }
const _hoisted_3 = { class: "question" }
const _hoisted_4 = { class: "form-item-body" }
const _hoisted_5 = { class: "stats-data" }
const _hoisted_6 = {
  key: 0,
  class: "option-value"
}
const _hoisted_7 = {
  key: 1,
  class: "option-value"
}
const _hoisted_8 = {
  key: 2,
  class: "option-percentage"
}
const _hoisted_9 = {
  key: 3,
  class: "option-percentage"
}
const _hoisted_10 = { class: "progress-bar" }
const _hoisted_11 = { class: "submission-info-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        class: "gorate-bg-inverted cursor-default",
        icon: _ctx.getFormItemIconIndex,
        height: "30",
        variant: "text",
        width: "30"
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formItem.question_lang1), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItem.form_item_options, (formItemOption, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "option-container",
          key: index
        }, [
          _createElementVNode("div", _hoisted_5, [
            formItemOption
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(formItemOption.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "N/A")),
            (!_ctx.hasDistributionData(_ctx.formItemIndex-1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "0%"))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.getDistributionCount(_ctx.formItemIndex-1, index, formItemOption?.value)) + " (" + _toDisplayString(_ctx.getDistributionPercentage(_ctx.formItemIndex-1, index, formItemOption?.value).toFixed(1)) + "%)", 1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.hasDistributionData(_ctx.formItemIndex-1))
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  rounded: "",
                  color: "#313336",
                  "model-value": "0",
                  height: 8
                }))
              : (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 1,
                  rounded: "",
                  color: "#313336",
                  "model-value": _ctx.getDistributionPercentage(_ctx.formItemIndex-1, index, formItemOption?.value),
                  height: 8
                }, null, 8, ["model-value"]))
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('i18n.submissions')) + ": " + _toDisplayString(_ctx.getTotalResponses(_ctx.formItemIndex - 1)), 1)
    ])
  ]))
}